module.exports = __webpack_public_path__ + "img/play.177e06e8.png";